module.exports = __webpack_public_path__ + "static/media/Roboticon02.ed489296.png";